export const useGeneralStore = defineStore('general', {
  state: () => {
    return {
      isBurgerMenuOpen: false,
    };
  },
});
